module.exports = __webpack_public_path__ + "media/shared/assets/fonts/InterDisplay/InterDisplay-Light-878eccfa0e5c8240899d9a9588d25926.woff2";